export default "__VITE_ASSET__DBymGjiW__"